var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCarousel
    ? _c(
        "carousel",
        {
          key: "carousel-" + _vm.filteredCards.length,
          attrs: { selector: ".carousel-wrapper", variant: "dashboard" },
        },
        [
          _c(
            "section",
            { staticClass: "carousel dashboard-carousel component standard" },
            [
              _c(
                "div",
                { staticClass: "carousel-wrapper show1" },
                _vm._l(_vm.filteredCards, function (card, i) {
                  return _c("dashboard-card", {
                    key: "card-" + i + _vm.filteredCards.length,
                    attrs: { card: card, "card-index": i },
                    on: {
                      dismissClicked: function ($event) {
                        return _vm.handleDismissClick($event)
                      },
                    },
                  })
                }),
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }